export const ContactSideData = [
  { name: "Directorate General", id: "dg" },
  { name: "Customer Care Centers", id: "ccc" },
  { name: "FC & GB Circle Islamabad", id: "gbc" },
  { name: "AJK Circle Muzaffarabad", id: "ajkc" },
  { name: "Postmaster General Punjab", id: "gpun" },
  { name: "Northern Punjab Circle Rawalpindi", id: "npun" },
  { name: "Central Punjab Circle Lahore", id: "cpun" },
  { name: "Southern Punjab Circle Multan", id: "spun" },
  { name: "Postmaster General Sindh & Baluchistan", id: "gsb" },
  { name: "Metropolitan Circle Karachi", id: "karc" },
  { name: "Northern Sindh Circle Hyderabad", id: "nsin" },
  { name: "Balochistan Circle Quetta", id: "balc" },
  { name: "Khyber Pakhtunkhwa Circle Peshawar", id: "kpkc" },
];

export const ContactDG = [
  {
    designation: "Addl Director General (Admin)",
    name: "Hafiz Shakil Ahmed Qureshi",
    email: "",
    phone: "",
  },
  {
    designation: "Addl Director General (Accounts & Finance)",
    name: "Akbar Ali Dero",
    email: "",
    phone: "",
  },
  {
    designation: "Addl Director General (Financial Services)",
    name: "Atifa Raffat",
    email: "",
    phone: "+92-51-9107187",
  },
  {
    designation: "Addl Director General (Operations)",
    name: "Rizwan Javed Hashmi",
    email: "",
    phone: "",
  },
  {
    designation: "Dy. Director General (Op)",
    name: "Sqd Ldr(R) Maqsood Ahmed Baloch",
    email: "",
    phone: "",
  },
  {
    designation: "Dy. Director General (Admn)",
    name: "Fazal Karim Mughal",
    email: "",
    phone: "",
  },
  {
    designation: "Dy. Director General (SI)",
    name: "Muhammad Zaheer",
    email: "",
    phone: "",
  },
  {
    designation: "Chief Accounts Officer",
    name: "Syed Ishtiaq Ur Rehman",
    email: "",
    phone: "",
  },
  {
    designation: "Director (Admin)/ Focal Person of PPOD",
    name: "Fazal Karim Mughal",
    email: "dir.admin@pakpost.gov.pk",
    phone: "",
  },
  {
    designation: "Director International Postal Services",
    name: "Farhan Ali Mirza",
    email: "dips@pakpost.gov.pk",
    phone: "+92-51-9260257",
  },
  {
    designation: "Customer Complaints (Pakistan Post)",
    name: "",
    email: "customercare@pakpost.gov.pk",
    phone:
      "111-111-117 & +92-51-8487080 (From Landline) 051-111-111-117 (From Cell Phone)",
  },
  {
    designation: "Complaints (Federal Ombudsman)",
    name: "Dr. Jamal Yosuf, Registrar, WAFAQI MOHTASIB (OMBUDSMAN)'S SECRETARIAT, Head Office, Wafaqi Mohtasib Secretarait, Constitution Avenue G-5/2, Islamabad",
    email: "ombuds.munawarsajjad@gmail.com",
    phone: "051-9213886",
  },
];
export const ContactCCC = [
  {
    designation: "PMG LAHORE",
    name: "AD (Comp)",
    email: "ccpmgpunjab@yahoo.com",
    phone: "042-99213502",
  },
  {
    designation: "PMG KARACHI",
    name: "PMG KHI",
    email: "pmgkarachi@yahoo.com",
    phone: " 021-99250106 &  021-99250106",
  },
  {
    designation: "PMG HYDERABAD",
    name: "APMG(OP)",
    email: "Pmg-nschyd@yahoo.com",
    phone: "022-9200358",
  },
  {
    designation: "PMG MULTAN",
    name: "APMG",
    email: "pmgmul@gmail.com",
    phone: "061-9201104",
  },
  {
    designation: "PMG RAWALPINDI",
    name: "AD(CC & Sav)",
    email: "adccpmgnprwp@gmail.com",
    phone: "051-9270049",
  },
  {
    designation: "PMG ISLAMABAD",
    name: "APMG(FS)",
    email: "pmgibd@yahoo.com",
    phone: "051-9261908 & 051-9260389",
  },
  {
    designation: "PMG QUETTA",
    name: "PA To PMG",
    email: "Pmgquetta@yahoo.com",
    phone: "081-9211529",
  },
  {
    designation: "PMG PESHAWAR",
    name: "AD (Comp)",
    email: "pmgpsh@pakpost.gov.pk & ad.compt.psh@pakpost.gov.pk",
    phone: "091-9212246 & 091-9213331",
  },
  {
    designation: "PMG AJK, MUZAFFARABAD",
    name: "APMG",
    email: "ajkregion@gmail.com",
    phone: "05822-921301 & 05822-921304",
  },
  {
    designation: "Controller IMO (P) KARACHI",
    name: "Controller IMO (Parcel)",
    email: "pkkhid@gmail.com",
    phone: "021-99211130",
  },
  {
    designation: "Dy. Controller IMO (L) KARACHI",
    name: "Dy. Controller IMO (L)",
    email: "gcss.prime@gmail.com",
    phone: "021-99240532",
  },
  {
    designation: "Dy. Controller EP KARACHI",
    name: "Dy. Controller (EP)",
    email: "dcepkhi.pakpost.gov@gmail.com",
    phone: "021-99333126",
  },
  {
    designation: "Controller IMO Islamabad",
    name: "Controller IMO",
    email: "pkisba@gmail.com",
    phone: "051-9281273",
  },
  {
    designation: "Controller IMO Lahore",
    name: "Controller IMO Lahore",
    email: "parcelexportlahore@yahoo.com",
    phone: "042-99214632",
  },
  {
    designation: "Dy. Controller Foreign Post SIALKOT",
    name: "Dy. Controller F.P",
    email: "asfpskt@yahoo.com",
    phone: "052-9250046",
  },
];
export const ContactGB = [
  {
    designation: "Postmaster General",
    name: "Rashid Ullah Khan Kundi",
    email: "pmgibd@yahoo.com",
    phone: "+92-51-9260111 & +92-51-9261922",
  },
  {
    designation: "Dy. Postmaster General (Admin)",
    name: "Saima Mukhtar",
    email: "",
    phone: "+92-51-9262032",
  },
];
export const ContactAJK = [
  {
    designation: "Postmaster General",
    name: "Yasir Ali Wasti",
    email: "+92-05822-921303",
    phone: "051-9632340",
  },
  {
    designation: "Assistant Postmaster General",
    name: "",
    email: "",
    phone: "+92-05822-921303",
  },
];
export const ContactPGP = [
  {
    designation: "Postmaster General Punjab Province Lahore",
    name: "Moazzam Mansoor",
    email: "pmgpunjab@yahoo.com",
    phone: "+92-42-9210729 & +92-42-9210717",
  },
];
export const ContactNPC = [
  {
    designation: "Postmaster General",
    name: "Nisar Muhammad Khan",
    email: "pmgnprwp@hotmail.com",
    phone: "+92-51-9271566 & +92-51-9271345",
  },
  {
    designation: "Dy. Postmaster General (Admin)",
    name: "Muhammad Arshad",
    email: "",
    phone: "+92-51-9271561 & +92-51-9271568",
  },
  {
    designation: "Dy.Postmaster General (FS)",
    name: "Noor-Ul-Saba",
    email: "",
    phone: "",
  },
  {
    designation: "Computer Programmer",
    name: "Muhammad Ismail",
    email: "",
    phone: "+92-51-9271553 & +92-51-9271568",
  },
];
export const ContactCPC = [
  {
    designation: "Postmaster General",
    name: "Moazzam Mansoor",
    email: "pmgcpunjab@yahoo.com",
    phone: "+92-42-99210721 & +92-42-99211329",
  },
  {
    designation: "Dy. Postmaster General (Admin)",
    name: "",
    email: "shoaibjaffri@hotmail.com",
    phone: "+92-42-99210713 & +92-42-99210550",
  },
  {
    designation: "Dy. Postmaster General (Ops)",
    name: "Anwar-Ul-Haq Kharal",
    email: "pmgcpunjab@yahoo.com",
    phone: "+92-42-99211330 & +92-42-99211323",
  },
  {
    designation: "Dy. Postmaster General (FS)",
    name: "Sadia Naseem Ghazala",
    email: "pmgcpunjab@yahoo.com",
    phone: "+92-42-99211330 & +92-42-99211323",
  },
];
export const ContactSPC = [
  {
    designation: "Postmaster General",
    name: "Zulfiqar Hussain",
    email: "",
    phone: "+92-61-9200371 & +92-61-9200372",
  },
  {
    designation: "Dy. Postmaster General (Admin)",
    name: "Zulfiqar Hussain",
    email: "",
    phone: "+92-61-9200371 & +92-61-9200372",
  },
];
export const ContactPGSB = [
  {
    designation: "Postmaster General Sindh & Baluchistan",
    name: "Manzoor Ahmed",
    email: "",
    phone: "+92-21-99203934",
  },
];
export const ContactMCK = [
  {
    designation: "Postmaster General",
    name: "Mustafa Kamal",
    email: "pmgkarachi@yahoo.com",
    phone: "+92-21-99250106 & +92-21-99250109",
  },
  {
    designation: "Chairman/ Director General",
    name: "Mustafa Kamal",
    email: "dpmgkar@yahoo.com",
    phone: "+92-21-99250106 & +92-21-99250109",
  },
  {
    designation: "Dy. Postmaster General( Ops)",
    name: "",
    email: "dpmg-ops-mck@outlook.com",
    phone: "+92-21-99250107",
  },
  {
    designation: "Asstt.Postmaster General (I&V)",
    name: "Muhammad Ashraf Soomro",
    email: "apmginvcokarachi@gmail.com",
    phone: "+92-21-99250114",
  },
  {
    designation: "Computer Programmer",
    name: "Jehanzeb",
    email: "compgrammer@gmail.com",
    phone: "+92-21-992501397",
  },
  {
    designation: "Assistant Director (Complaint)",
    name: "Abdul Sattar",
    email: "pmgmck.compt@gmail.com",
    phone: "+92-21-99250129",
  },
];
export const ContactNSC = [
  {
    designation: "Postmaster General",
    name: "Akbar Ali Dero",
    email: "pmg_nschyd@yahoo.com",
    phone: "+92-22-9200438",
  },
  {
    designation: "Dy. Postmaster General (Admin)",
    name: "Najeeb-ur-Rehman",
    email: "",
    phone: "+92-22-9200580 & +92-22-9200438",
  },
];
export const ContactBCQ = [
  {
    designation: "Postmaster General",
    name: "Noman Falahuddin",
    email: "pmgquetta@yahoo.com",
    phone: "+92-81-9211529 & +92-81-9211521",
  },
  {
    designation: "Dy. Postmaster General",
    name: "Israr-Ul-Haq",
    email: "dypmg.qta@pakpost.gov.pk",
    phone: "",
  },
  {
    designation: "Dy.Postmaster General (Ops)",
    name: "Manzoor Ahmed Bangalzai",
    email: "",
    phone: "+92-81-9211528",
  },
  {
    designation: "Computer Programmer",
    name: "",
    email: "itofficer.qta@pakpost.gov.pk",
    phone: "+92-81-9211524",
  },
];
export const ContactKPC = [
  {
    designation: "Postmaster General",
    name: "Nisar Muhammad Khan",
    email: "",
    phone: "+92-91-9213375 & +92-91-9213381",
  },
  {
    designation: "Dy. Postmaster General (Admin)",
    name: "Muhammad Imran Khan",
    email: "",
    phone: "+92-91-9211844 & +92-91-9210232",
  },
  {
    designation: "Dy. Postmaster General (Ops)",
    name: "Abdul Sattar",
    email: "",
    phone: "+92-91-9213388 & +92-91-9210232",
  },
];
